module.exports = fox => {
	return fox.extend(function (pm/* permissionManager */, params /* ruleParams */) {
		this.__constructor.apply(this, arguments);
	}, {
		__constructor: function (pm, params) {
			this.pm = pm;
			this.params = {};
			this.wasChanged = false;

			var _this = this;

			this.setParams = (key, value) => {
				if (fox.isObject(key)) {
					return fox.getObjectKeys(key).forEach(prop => this.setParams(prop, key[prop]));
				}

				if (!(key in params)) {
					params[key] = value;
				}

				if (!(key in this.params)) {
					return Object.defineProperty(this.params, key, {
						get: function () {
							return params[key];
						},
						set: function (value) {
							_this.wasChanged = true;
							params[key] = value;
						}
					});
				}

				this.params[key] = value;
			};

			this.setParams(params);
		},

		super: function () {
			var args = fox.clone(arguments);

			return fox.callSuperMethod.apply(this, args.concat('super'));
		},

		execute: function () {
			if (this.hasAccess() && fox.isFunction(this.granted)) {
				return this.granted.apply(this, arguments);
			}
			
			if (!this.hasAccess() && fox.isFunction(this.denied)) {
				return this.denied.apply(this, arguments);
			}
		},

		getParams: function (prop) {
			if (prop) return fox.objectGet(this.params, prop);

			return this.params;
		},

		addRouteHook: function () {
			var params = {};

			params.performer = this.pm;
			params.prefix = [this.pm.getHash(), this._className].join('_').toLowerCase();

			this.pm.getEm().handleHook('@root #router', 'onStartSetActiveRoute', this.onRoute.bind(this), params);
		},

		onRoute: function () {},

		hasAccess: function () {
			var result = [];

			if (fox.isObject(this.params)) {
				switch (true) {
					case ('enabled' in this.params):
						result.push(this.params.enabled);
					break;
				}
			}

			return result.length > 0 &&
				result.every(value => value === true);
		},
	}, null, 'Rule_Base');
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rule.es.js